import styled from 'styled-components';

/**
 * The Transcript tab's frame, shared by the tab (`TranscriptSpeakersContent`)
 * and the skeleton that stands in for it while the transcript loads
 * (`TranscriptTabSkeleton`). Both position their regions from these numbers,
 * so the skeleton cannot drift from the page it promises (PLAT-12125).
 */

/* PLAT-11877 — 84px (was 105): the strip is a card now, and a fifth less
   tall gives the transcript the room back without the bars losing their
   read. Collapsed is the header row alone. */
export const WAVEFORM_EXPANDED_HEIGHT = 84;
export const WAVEFORM_COLLAPSED_HEIGHT = 34;

/* PLAT-11877 — the right column is the Translation Review's card: a
   `--surface` panel with the review's radius, the player at its top edge and
   the speakers list inset below, set off from the transcript by one gutter
   instead of a rule. */
export const RIGHT_COLUMN_WIDTH = 360;
export const RIGHT_COLUMN_GUTTER = 16;
export const RIGHT_COLUMN_SPAN = RIGHT_COLUMN_WIDTH + RIGHT_COLUMN_GUTTER;

export const TranscriptTabContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 70px);
  margin-top: -15px;
`;
